import React, { Children } from 'react'
import './styles.scss'
import { config } from './config'

interface Props {
  children: JSX.Element | string
}

export const SectionHead = ({ children }: Props) => (
  <div className='sectionhead'>
    <div className='line' />

    <div className='text'>
      <span>{children}</span>
    </div>
  </div>
)
